export function handleError(error: any) {
  // Optional chaining guards every level (error itself, .response, .data), not just
  // .response — a response can exist without a body shaped like { errors }, which
  // otherwise rejects with `undefined` and surfaces as "Unknown promise rejection
  // reason" in the browser instead of a real, catchable error.
  const errorMessage = error?.response?.data?.errors || { message: "connection error", name: "" };
  return Promise.reject(errorMessage);
}
